import styled from 'styled-components'
import { Icon } from '../icon'

type ExternalLinkProps = {
  text: string
  href: string
  onClick?: () => void
  className?: string
  hideIcon?: boolean
}

const StyledExternalLink = styled.a`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${theme.colors.primary400};
  font-size: ${theme.fontSizes.bodySmall};
  font-weight: ${theme.fontWeights.medium};
  text-decoration: underline;

  > svg {
    transform: rotate(45deg);
  }
`}
`

export const ExternalLink = ({
  text,
  href,
  onClick,
  className,
  hideIcon = false,
}: ExternalLinkProps) => (
  <StyledExternalLink
    href={href}
    target="_blank"
    rel="noreferrer"
    onClick={onClick}
    className={className}
  >
    {!hideIcon && <Icon name="arrow-up" size="m" />}
    <span>{text}</span>
  </StyledExternalLink>
)
